import * as React from 'react'
import * as classNames from 'classnames'
import {
  PageErrorBanner,
  PageErrorBannerContainer,
  PageErrorChildContainer,
  PageErrorDescription,
  PageErrorMessage,
} from './page-error.styles'

interface NoResultsBannerProps extends React.HTMLAttributes<HTMLDivElement> {
  error?: string
  errorDescription?: string
  children?: React.ReactNode
}

export const PageErrorBannerComponent: React.FC<NoResultsBannerProps> = ({
  children,
  className,
  error,
  errorDescription,
}) => (
  <PageErrorBannerContainer className={classNames(className)}>
    <PageErrorBanner />
    {error && <PageErrorMessage>{error}</PageErrorMessage>}
    {errorDescription && (
      <PageErrorDescription>{errorDescription}</PageErrorDescription>
    )}
    <PageErrorChildContainer>{children}</PageErrorChildContainer>
  </PageErrorBannerContainer>
)
